<template>
  <div>
    <app-heading :text="'NBN Orders'" :heading="'main'"></app-heading>

    <v-row class="mb-4">
      <v-col cols="12" sm="9" md="9" class="py-0">
        <v-row>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Completed"
              v-model="filterCompleted"
              class="custom-width"
              @change="getOrdersData()"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="InProgress"
              v-model="filterInProgress"
              class="custom-width"
              @change="getOrdersData()"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Rejected"
              v-model="filterRejected"
              class="custom-width"
              @change="getOrdersData()"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Withdrawn"
              v-model="filterCancelled"
              class="custom-width"
              @change="getOrdersData()"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Cancelled"
              v-model="filterDisconnected"
              class="custom-width"
              @change="getOrdersData()"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Transferred Out"
              v-model="filterTransferredOut"
              class="custom-width"
              @change="getOrdersData()"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="8"
        lg="9"
        class="pt-0 pb-0"
        :class="$vuetify.breakpoint.xs ? 'pr-3' : 'pr-0'"
      >
        <v-btn
          class="primary"
          @click="createNbnOrder({})"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
          >Create New Order</v-btn
        >
        <v-btn
          class="primary"
          @click="exportRecords()"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4 ml-0' : 'mt-6 ml-5'"
          >Export Records</v-btn
        >
        <v-btn
          v-if="canBulkUpload"
          class="primary"
          @click="showBulkUpload = true"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4 ml-0' : 'mt-6 ml-5'"
        >
          <v-icon left>mdi-upload</v-icon>
          Upload Records
        </v-btn>
      </v-col>

      <v-col cols="12" md="4" lg="3">
        <app-search @search="search"></app-search>
      </v-col>
    </v-row>

    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh; width: 100%"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      :undoRedoCellEditing="true"
      @grid-ready="onGridReady"
      :frameworkComponents="frameworkComponents"
      @cellClicked="onRowClicked"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
    ></ag-grid-vue>

    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="nbnDataOptions.totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>

    <create-nbn-order
      ref="createOrder"
      :showNewNbnOrder="showNewNbnOrder"
      :new-order="newOrder"
      @closeNbnOrder="closeNewOrder()"
      @orderSubmitted="closeNewOrder()"
      :filteredParties ="parties"
      :requireWholesalerSelection="requireWholesalerSelection"
    ></create-nbn-order>

    <order-status
      :dialog="statusDialog"
      :orderId="selectedOrderID"
      @closeDialog="statusDialog = false"
    ></order-status>

    <nbn-bulk-upload
      :showDialog="showBulkUpload"
      @closeBulkUpload="showBulkUpload = false"
      @bulkUploadError="handleBulkError"
    ></nbn-bulk-upload>

  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import TableActions from "@/components/common/nbn-table-actions";
import { AgGridVue } from "ag-grid-vue";
import NbnBulkUpload from "@/components/orderQualification/nbn-bulk-upload";
import storeMixin from "@/mixins/store.mixin";

export default {
  name: "NbnOrderManagement",
  mixins: [storeMixin],
  components: { AgGridVue, NbnBulkUpload },
  data: () => ({
    paging: {
      pageNo: 1,
      pageSize: 25,
      keyword: ""
    },
    filterCompleted: false,
    filterInProgress: false,
    filterRejected: false,
    filterCancelled: false,
    filterDisconnected: false,
    filterTransferredOut: false,
    nbnDataOptions: {},
    page: 1,
    currentPage: 1,
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true
    },
    showNewNbnOrder: false,
    showBulkUpload: false,
    columnDefs: null,
    gridOptions: {},
    items: [],
    frameworkComponents: null,
    newOrder: {
      contactNumber: "1800828668",
      contactFirstname: "2SG",
      contactSurname: "Support"
    },
    statusDialog: false,
    selectedOrderID: "",
    orderStatusFilter: [],
    parties: [],
    requireWholesalerSelection: false,
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
    vm.$refs.createOrder.setWholesaler();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {
      suppressMenuHide: true,
      alwaysShowVerticalScroll: false,
      alwaysShowHorizontalScroll: false
    };
    vm.frameworkComponents = {
      tableActions: TableActions
    };
    vm.columnDefs = [
      {
        headerName: "Order Details",
        field: "actions",
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function(param) {
            vm.existingOrder = true;
            switch (param.type) {
              // case "appointment":
              //   vm.$emit("showAppointment", param);
              //   break;
              case "order":
                vm.retrieveOrderBandwidth(param.nbnOrderId);
                vm.openOrderWithTags(param);
                break;
              // case "modifyOrder":
              //   vm.modifyNbnOrder(param);
              //   break;
              // case "disconnectOrder":
              //   break;
            }
          }
        },
        maxWidth: 200
      },
      {
        headerName: "Type",
        field: "orderType",
        sortable: true,
        maxWidth: 150,
        filter: true
      },
      {
        headerName: "Order ID",
        field: "nbnOrderId",
        sortable: true,
        filter: true,
        maxWidth: 195
      },
      {
        headerName: "Service ID",
        field: "avcId",
        sortable: true,
        filter: true,
        maxWidth: 195
      },
      {
        headerName: "Technology Type",
        field: "productType",
        sortable: true,
        filter: true,
        maxWidth: 195,
        valueGetter: params => {
          return `${
            params.data.productType == "Fibre"
              ? "FTTP"
              : params.data.productType
          }`;
        }
      },
      {
        headerName: "Radius Status",
        field: "radiusStatus",
        sortable: true,
        filter: true,
        maxWidth: 195,
        cellStyle: function(params) {
          if (params.value == "Online") {
            return { color: "green" };
          } else if (params.value == "Offline") {
            return { color: "red" };
          }
        },
        valueGetter: params => {
          return `${
            params.data.status.toLowerCase() == "cancelled" ||
            params.data.status.toLowerCase() == "disconnected"
              ? "Offline"
              : params.data.status.toLowerCase() == "rejected"
              ? "N/A"
              : params.data.radiusStatus
          }`;
        }
      },
      {
        headerName: "Customer Name",
        field: "customerName",
        sortable: true,
        filter: true,
        valueGetter: params => {
          return `${
            params.data.customerFirstname ? params.data.customerFirstname : ""
          } ${params.data.customerSurname ? params.data.customerSurname : ""}`;
        }
      },
      {
        headerName: "Wholesaler Name",
        field: "wholesaler",
        sortable: true,
        filter: true
      },
      {
        headerName: "Auth Date",
        field: "customerAuthDate",
        sortable: true,
        sort: "desc",
        valueFormatter: param => {
          return vm.$options.filters.formatDateTime(param.value);
        },
        comparator: vm.dateComparator,
        maxWidth: 150,
        filter: true,
        sortingOrder: ['desc', 'asc']
      },
      {
        headerName: "Status",
        field: "status",
        sortable: true,
        valueFormatter: param => {
          return vm.$options.filters.formatStatus(param.value);
        },
        cellStyle: function(params) {
          if (params.value == "Complete") {
            return { color: "green" };
          } else if (params.value == "Rejected") {
            return { color: "#FF0002" };
          }
        },
        resizable: true,
        minWidth: 160,
        maxWidth: 220,
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function(param) {
            vm.showStatusDialog(param);
          }
        }
      },
      {
        headerName: "Ticket #",
        field: "kayakoConversation",
        sortable: true,
        filter: true,
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function(param) {
            vm.showKayakoConversation(param);
          },
          shouldRedirect: vm.shouldRedirect
        },
        maxWidth: 120
      }
    ];

    vm.defaultColDef = {
      autoHeight: true,
      resizable: true
    };
    vm.getOrdersData();
  },
  watch: {
    canBulkUpload(allowed) {
      if (!allowed) this.showBulkUpload = false;
    }
  },
  computed: {
    filteredItems: function() {
      let vm = this;
      let items = vm.items;

      if (!items || items.length === 0) {
        return [];
      }

      if (
        !vm.filterCompleted &&
        !vm.filterInProgress &&
        !vm.filterRejected &&
        !vm.filterCancelled &&
        !vm.filterDisconnected &&
        !vm.filterTransferredOut
      ) {
        return items;
      }

      if (!vm.filterCompleted)
        items = items.filter(x => x.status !== "Complete");
      if (!vm.filterInProgress)
        items = items.filter(x => x.status !== "InProgress");
      if (!vm.filterRejected)
        items = items.filter(x => x.status !== "Rejected");
      if (!vm.filterCancelled)
        items = items.filter(x => x.status !== "Cancelled");
      if (!vm.filterDisconnected)
        items = items.filter(x => x.status !== "Disconnected");
      if (!vm.filterTransferredOut)
        items = items.filter(x => x.status !== "Transferred Out");

      return items;
    },
    shouldRedirect() {
      let vm = this;
      let redirect = true;

      if ((vm.impersonating !== null && !vm.isUserMember) || !vm.isAdmin)
        redirect = false;

      return redirect;
    }
  },
  methods: {
    dateComparator(valueA, valueB, nodeA, nodeB, isDescending) {
      if (!valueA && !valueB) return 0;
      if (!valueA) return 1;
      if (!valueB) return -1;

      const dateA = new Date(valueA).getTime();
      const dateB = new Date(valueB).getTime();

      if (isNaN(dateA) && isNaN(dateB)) return 0;
      if (isNaN(dateA)) return 1;
      if (isNaN(dateB)) return -1;

      return dateA - dateB;
    },
    technologyType(payload) {
      let type = "";
      switch (payload) {
        case "Fibre":
          type = "Fibre";
          break;
        case "Fibre To The Building":
          type = "FTTB";
          break;
        case "Fibre To The Node":
          type = "FTTN";
          break;
        case "Fibre To The Curb":
          type = "FTTC";
          break;
        case "Wireless":
          type = "Fixed Wireless";
          break;
        case "HFC":
          type = "HFC";
          break;
      }

      return type;
    },
    showStatusDialog(data) {
      let vm = this;
      vm.selectedOrderID = data.nbnOrderId;
      vm.statusDialog = true;
    },
    getOrdersData() {
      let vm = this;

      if (vm.filterCompleted) vm.orderStatusFilter.push(1);
      if (vm.filterInProgress) vm.orderStatusFilter.push(2);
      if (vm.filterRejected) vm.orderStatusFilter.push(3);
      if (vm.filterCancelled) vm.orderStatusFilter.push(4);
      if (vm.filterDisconnected) vm.orderStatusFilter.push(6);
      if (vm.filterTransferredOut) vm.orderStatusFilter.push(7);

      var search = {
        keyword: null,
        statusFilter: vm.orderStatusFilter,
        pageSize: vm.paging.pageSize,
        pageNumber: vm.paging.pageNo
      };

      vm.getNbnConnectOrders(search)
        .then(data => {
          var radiusUsernames = [];
          const items = data.items || (data.data && data.data.items) || [];
          items.forEach(x => {
            if (x.orderType.toLowerCase() === "nbn") {
              x.orderType = "NBN";

              try {
                const sqResponse = JSON.parse(x._sqResponse);
                if (sqResponse && sqResponse.parameters && sqResponse.parameters.parameter) {
                  sqResponse.parameters.parameter.forEach(param => {
                    if (param.name === "PrimaryAccessTechnology")
                      x.productType = vm.technologyType(param.value);
                  });
                }
              } catch (error) {
                console.error("Error parsing _sqResponse:", error);
              }

              if (x.radiusUsername !== null && x.radiusUsername !== "") {
                radiusUsernames.push(x.radiusUsername);
              }
            } else {
              var request = JSON.parse(x.request);
              x.productType = request.productType;
              if (x.radiusUsername != null && x.radiusUsername != "") {
                radiusUsernames.push(x.radiusUsername);
              } else if (
                request.existingRadiusUsername !== undefined &&
                request.existingRadiusUsername != ""
              ) {
                radiusUsernames.push(request.existingRadiusUsername);
              } else {
                x.radiusStatus = "N/A";
              }
            }
          });

          var radiusStatusPayload = { radiusUsername: radiusUsernames };
          vm.getServiceRadiusStatus(radiusStatusPayload)
            .then(response => {

              items.forEach(x => {
                if (x.orderType.toLowerCase() === "nbn") {
                  if (x.radiusUsername != null && x.radiusUsername != "")
                    x.radiusStatus = response[x.radiusUsername];
                  else x.radiusStatus = "N/A";
                } else {
                  var request = JSON.parse(x.request);
                  if (x.status == "Rejected") {
                    x.radiusStatus = "N/A";
                  } else {
                    if (x.radiusUsername != null && x.radiusUsername != "") {
                      x.radiusStatus = response[x.radiusUsername];
                    } else if (
                      request.existingRadiusUsername !== undefined &&
                      request.existingRadiusUsername != ""
                    ) {
                      x.radiusStatus = response[request.existingRadiusUsername];
                    }
                  }
                }

                if (x.status.toLowerCase() == "disconnected") {
                  x.radiusStatus = "Cancelled";
                }
              });

              vm.orderStatusFilter = [];
              vm.items = items;
              vm.nbnDataOptions = data.data || data;
              vm.gridApi.sizeColumnsToFit();
            })
            .catch(() => {});
        })
        .catch(e => {
          vm.items = [];
        });
    },
    paginationChange(val) {
      this.paging.pageNo = val;
      this.getOrdersData();
    },
    createNbnOrder(data) {
      let vm = this;
      vm.newOrder = {};
      vm.requireWholesalerSelection = true;
      vm.setFibreCheckbox(false);
      vm.setOriginal(false);
      vm.setEditForm(false);
      vm.existingOrder = false;
      vm.setLocationID("");
      vm.resetFormattedSQResult();
      vm.setSqResult({});
      vm.setOrderType("nbn");
      vm.createOrder(data);
      if (vm.wholesalers.length === 1) vm.$refs.createOrder.checkLayer();
    },
    showKayakoConversation(item) {
      let newItem = item.customerReference;
      if (item.customerReference.includes("_")) {
        newItem = item.customerReference.slice(
          item.customerReference.indexOf("_") + 1,
          item.customerReference.length
        );
      }
      var authDate = new Date(item.customerAuthDate);
      var zammadDeployDate = new Date("2024-04-18");
      if (authDate >= zammadDeployDate) {
        window.open(
          `https://zammad.vonex.com.au/#search/number:${newItem}`,
          "_blank"
        );
      } else {
        window.open(
          `https://vonex.kayako.com/agent/conversations/${newItem}`,
          "_blank"
        );
      }
    },
    search(keyword) {
      let vm = this;
      vm.paging.keyword = keyword;
      vm.keyword = keyword;

      if (vm.filterCompleted) vm.orderStatusFilter.push(1);
      if (vm.filterInProgress) vm.orderStatusFilter.push(2);
      if (vm.filterRejected) vm.orderStatusFilter.push(3);
      if (vm.filterCancelled) vm.orderStatusFilter.push(4);

      var search = {
        keyword: keyword,
        statusFilter: vm.orderStatusFilter,
        pageSize: 50,
        pageNumber: 1
      };

      vm.getNbnConnectOrders(search)
        .then(data => {
          var radiusUsernames = [];
          const items = data.items || (data.data && data.data.items) || [];   
          items.forEach((x)=> {
            let isNbn = false;
            let request = null;

            try {
              request = JSON.parse(x.request);
            } catch (error) {
              isNbn = true;
            }


            if(isNbn){
            x.orderType = "NBN";

              try {
                const sqResponse = JSON.parse(x._sqResponse);
                if (sqResponse && sqResponse.parameters && sqResponse.parameters.parameter) {
                  sqResponse.parameters.parameter.forEach(param => {
                    if (param.name === "PrimaryAccessTechnology")
                      x.productType = vm.technologyType(param.value);
                  });
                }
              } catch (error) {
                console.error("Error parsing _sqResponse:", error);
              }

            if(x.radiusUsername !== null && x.radiusUsername !== "")
            {
              radiusUsernames.push(x.radiusUsername);
            }
           }else{
            x.productType = request.productType;
            if(x.radiusUsername != null && x.radiusUsername != "")
            {
              radiusUsernames.push(x.radiusUsername);
            } else if (request.existingRadiusUsername !== undefined && request.existingRadiusUsername != "")
            {
              radiusUsernames.push(request.existingRadiusUsername);
            } else {
              x.radiusStatus = 'N/A';
            }
           }
          });

          var radiusStatusPayload = { radiusUsername: radiusUsernames };
          vm.getServiceRadiusStatus(radiusStatusPayload)
            .then(response => {
              items.forEach(x => {
                if (x.orderType.toLowerCase() === "nbn") {
                  if (x.radiusUsername != null && x.radiusUsername != "")
                    x.radiusStatus = response[x.radiusUsername];
                  else x.radiusStatus = "N/A";
                } else {
                  var request = JSON.parse(x.request);
                  if (x.status == "Disconnected") x.radiusStatus = "Cancelled";
                  else if (x.status == "Rejected") {
                    x.radiusStatus = "N/A";
                  } else {
                    if (x.radiusUsername != null && x.radiusUsername != "") {
                      x.radiusStatus = response[x.radiusUsername];
                    } else if (
                      request.existingRadiusUsername !== undefined &&
                      request.existingRadiusUsername != ""
                    ) {
                      x.radiusStatus = response[request.existingRadiusUsername];
                    }
                  }
                }
              });
              vm.orderStatusFilter = [];
              vm.items = items;
              vm.gridApi.sizeColumnsToFit();
            })
            .catch((e) => {
              console.error("Error fetching radius status:", e);
            });
        })
        .catch((e) => {
          console.error("Error fetching NBN orders:", e);
          vm.items = [];
        });
    },
    modifyNbnOrder(data) {
      let vm = this;
      vm.showNewNbnOrder = true;
    },
    createOrder(details) {
      let vm = this;

      vm.showNewNbnOrder = true;
    },
    closeNewOrder() {
      let vm = this;
      vm.showNewNbnOrder = false;
      vm.requireWholesalerSelection = false;
      vm.resetNbnOrderDetails();
      vm.setOriginal(false);
      vm.setEditForm(false);
      vm.getOrdersData();
    },
    openOrderWithTags(param) {
      let vm = this;
      // Prefer tags already on the order row (e.g. nbnCtag/nbnStag from GetNbnConnectOrders).
      const existingCTag =
        param.cTag ||
        param.nbnCtag ||
        param.nbnCTag ||
        param.NbnCtag;
      const existingSTag =
        param.sTag ||
        param.nbnStag ||
        param.nbnSTag ||
        param.NbnStag;

      if (existingCTag || existingSTag) {
        param.cTag = existingCTag || "";
        param.sTag = existingSTag || "";
        vm.showOriginal(param);
        return;
      }

      // Fallback: fetch from GetAdvancedCTag for non-Layer3 when AVC exists.
      if (param?.avcId && !vm.isLayer3 && process.env.NODE_ENV === 'production') {
        vm.retrieveTagDetails(param.avcId)
          .then(data => {
            const tags = data?.data ?? data ?? {};
            param.cTag = tags.CTag ?? tags.cTag ?? "";
            param.sTag = tags.STag ?? tags.sTag ?? "";
            vm.showOriginal(param);
          })
          .catch(() => {
            vm.showOriginal(param);
          });
      } else {
        vm.showOriginal(param);
      }
    },
    async showOriginal(item) {
      let vm = this;
      const priId = item.priId;
      if (priId && item.status == "Transferred Out") {
        await vm.GetTransferredDate(priId);
      }

      vm.setOrderType(item.orderType.toLowerCase());
      vm.setOriginal(true);
      vm.setEditForm(false);
      vm.$refs.createOrder.displayOrder(item, {});
      if (vm.isOriginal) {
        var search = {
          keyword: vm.nbnOrder.avcId,
          statusFilter: -1,
          pageSize: 50,
          pageNumber: 1
        };

        vm.getTickets(search)
          .then(data => {
            if (data.items.length > 0) {
              vm.$refs.createOrder.setTickets(
                data.items.map(item => item.ticketId)
              );
            }
          })
          .catch(() => {});
      }
      vm.showNewNbnOrder = true;
      vm.checkHardwareModem(item);
      if (item.orderType.toLowerCase() === "nbn") vm.setOldOrder(true);
    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    onRowClicked(args) {
      var payload = { quoteID: args.data.quoteId };
    },
    handleBulkError(error) {
      let vm = this;
      vm.setHttpResponse({
        text: `Bulk upload error: ${error.message || error}`,
        color: "error"
      });
    },
    exportRecords() {
      let vm = this;
      var headers = [
        "Order Id",
        "AVC Id",
        "Location Id",
        "Technology Type",
        "Cpi Id",
        "Ntd Id",
        "Customer Name",
        "Auth Date",
        "Completed Date",
        "Service Status",
        "Kayako Ticket Id",
        "Bandwidth Profile",
        "Fibre Upgrade"
      ];
      let payload = {
        statusFilter: []
      };

      if (vm.filterCompleted) payload.statusFilter.push(1);
      if (vm.filterInProgress) payload.statusFilter.push(2);
      if (vm.filterRejected) payload.statusFilter.push(3);
      if (vm.filterCancelled) payload.statusFilter.push(4);
      if (vm.filterDisconnected) payload.statusFilter.push(6);
      if (vm.filterTransferredOut) payload.statusFilter.push(7);

      vm.getExportableNbnOrders(payload)
        .then(() => {
          vm.exportCSVFile(headers, vm.gettimestamp());
        })
        .catch(() => {});
    },
    exportCSVFile(headers, fileTitle) {
      let vm = this;
      if (headers) {
        vm.reportData.unshift(headers);
      }
      const jsonObject = JSON.stringify(vm.reportData);
      const csv = vm.convertToCSV(jsonObject);
      const exportedFilenmae = fileTitle + ".csv" || "export.csv"; // eslint-disable-line
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    convertToCSV(objArray) {
      const array =
        typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
      let str = "";
      for (let i = 0; i < array.length; i++) {
        let line = "";
        for (const index in array[i]) {
          if (line !== "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
    gettimestamp() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return "NBN Orders " + date + " " + time;
    }
  }
};
</script>

<style lang="scss" scoped>
.ag-font-style {
  user-select: initial;
  -moz-user-select: text;
  -ms-user-select: text;
  -webkit-user-select: text;
}
</style>

<style lang="scss">
.ag-theme-alpine .ag-header-cell-sorted-asc .ag-icon-asc {
  transform: rotate(180deg);
}

.ag-theme-alpine .ag-header-cell-sorted-desc .ag-icon-desc {
  transform: rotate(180deg);
}
</style>


